import { For, type JSX, Show } from 'solid-js';
import type { MachineRemovals } from '../lib/machine-removals';
import { MachineRemoveNotice } from './MachineRemoveNotice';

// The Fleet page's pending token-cascade failures (#6563 review): one persistent notice
// per removed machine whose access tokens are not all revoked, independent of the details
// panel (`createMachineRemovals`). Presenter: each notice reads its own parked removal.

export function MachineRemovalNotices(props: { readonly removals: MachineRemovals }): JSX.Element {
  return (
    <Show when={props.removals.parked().length > 0}>
      <div class="machine-removals">
        <For each={props.removals.parked()}>
          {(entry) => (
            <Show when={entry.remove.state()}>
              {(state) => (
                <MachineRemoveNotice
                  state={state()}
                  busy={entry.remove.busy()}
                  onRetry={entry.remove.retry}
                  onDismiss={() => props.removals.dismiss(entry.id)}
                />
              )}
            </Show>
          )}
        </For>
      </div>
    </Show>
  );
}
